/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Meta_Needs_SetupInputs */

const cs_social_hub_meta_needs_setup = /** @type {(inputs: Social_Hub_Meta_Needs_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojeno — dokončete výběr stránky`)
};

const en_social_hub_meta_needs_setup = /** @type {(inputs: Social_Hub_Meta_Needs_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected — finish page setup`)
};

/**
* | output |
* | --- |
* | "Connected — finish page setup" |
*
* @param {Social_Hub_Meta_Needs_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_meta_needs_setup = /** @type {((inputs?: Social_Hub_Meta_Needs_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Meta_Needs_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_meta_needs_setup(inputs)
	return cs_social_hub_meta_needs_setup(inputs)
});